import { defineMessages } from '@/i18n'

/**
 * Тексты превью экранов. Подписи CTA и заголовки, которых нет в данных,
 * взяты у ПЛЕЕРА (см. CLAUDE.md) — русские менять нельзя.
 */
export const messages = defineMessages({
  ru: {
    a11yVideo: 'Видео',
    correct: 'Правильно!',
    incorrect: 'Неправильно',
    accepted: 'Ответ отправлен',
    next: 'Далее',
    noArticle: 'Статья не выбрана',
    chooseArticle: 'Выберите статью',
    searchArticle: 'Поиск статьи',
    articlesLoadFailed: 'Не удалось загрузить статьи',
    nothingFound: 'Ничего не найдено',
    confirm: 'Подтвердить',
    questionPlaceholder: 'Введите вопрос...',
    variantN: (n: number) => `Вариант ${n}`,
    unavailable: 'Недоступно',
    fillBlankSample: 'Столица Франции — ___',
    fillBlankTitle: 'Заполни пропуск',
    dropImage: 'Нажмите или перетащите картинку',
    imageFormats: 'PNG, JPG, WebP · до 5 МБ',
    matchTitle: 'Сопоставьте термин с описанием',
    sendAnswer: 'Отправить ответ',
    dropVideo: 'Нажмите или перетащите видео',
    videoFormats: 'MP4, WebM, MOV, AVI · до 500 МБ',
    yes: 'Да',
    no: 'Нет',
    statementPlaceholder: 'Введите утверждение...',
  },
  en: {
    a11yVideo: 'Video',
    correct: 'Correct!',
    incorrect: 'Incorrect',
    accepted: 'Answer sent',
    next: 'Next',
    noArticle: 'No article selected',
    chooseArticle: 'Choose an article',
    searchArticle: 'Search articles',
    articlesLoadFailed: 'Couldn’t load articles',
    nothingFound: 'Nothing found',
    confirm: 'Confirm',
    questionPlaceholder: 'Enter a question...',
    variantN: (n: number) => `Option ${n}`,
    unavailable: 'Unavailable',
    fillBlankSample: 'The capital of France is ___',
    fillBlankTitle: 'Fill in the blank',
    dropImage: 'Click or drag an image here',
    imageFormats: 'PNG, JPG, WebP · up to 5 MB',
    matchTitle: 'Match each term with its description',
    sendAnswer: 'Send answer',
    dropVideo: 'Click or drag a video here',
    videoFormats: 'MP4, WebM, MOV, AVI · up to 500 MB',
    yes: 'Yes',
    no: 'No',
    statementPlaceholder: 'Enter a statement...',
  },
})
